import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaChevronLeft } from "react-icons/fa";
import ProviderAvailabilityTab from "../../components/ProviderAvailabilityTab";
import { markSectionVisited } from "../../utils/providerOnboarding";
import "../../components/ProviderDetails.css";
import classes from "./AvailabilityOnboarding.module.css";

const AvailabilityOnboarding = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state?.user?.user);
  const providerId = user?.providerId;

  useEffect(() => {
    if (providerId) {
      markSectionVisited("availability", providerId);
    }
  }, [providerId]);

  if (!providerId) {
    return (
      <div className={classes.error}>
        Provider profile not found. Please sign in again.
      </div>
    );
  }

  return (
    <div className={classes.page}>
      <div className={classes.header}>
        <button
          type="button"
          className={classes.backBtn}
          aria-label="Back to onboarding"
          onClick={() => navigate("/dashboard")}
        >
          <FaChevronLeft />
        </button>
        <div>
          <h1 className={classes.title}>Availability</h1>
          <p className={classes.subtitle}>
            Set the days and times clients can schedule sessions with you.
          </p>
        </div>
      </div>

      <div className={classes.content}>
        <ProviderAvailabilityTab
          getProviderId={() => providerId}
          canManage
        />
      </div>
    </div>
  );
};

export default AvailabilityOnboarding;
